import { render, staticRenderFns } from "./CursoEntregables.vue?vue&type=template&id=12fb937b&scoped=true&"
import script from "./CursoEntregables.vue?vue&type=script&lang=js&"
export * from "./CursoEntregables.vue?vue&type=script&lang=js&"
import style0 from "./CursoEntregables.vue?vue&type=style&index=0&id=12fb937b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fb937b",
  null
  
)

export default component.exports